module.exports = __webpack_public_path__ + "static/img/m14.92dac07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m14.png
// module id = OP7M
// module chunks = 12